/**
 * Free gift in the cart.
 *
 * Adds one gift variant once the cart reaches the threshold and removes it again below.
 * The gift is only free once a matching automatic discount exists in the admin, so this
 * file is loaded only when `cart_gift_enabled` is on. Threshold and variant come from the
 * theme settings and are passed in on the script tag.
 */
(() => {
  const script = document.currentScript;
  const variantId = String(script.dataset.variantId || '');
  const threshold = Math.round(parseFloat(script.dataset.threshold || '0') * 100);

  if (!variantId || !threshold) return;

  let running = false;

  const subtotalWithoutGift = (cart) => {
    const gift = cart.items.find((item) => String(item.variant_id) === variantId);
    return cart.items_subtotal_price - (gift ? gift.final_line_price : 0);
  };

  const sync = async () => {
    if (running) return;
    running = true;

    try {
      const cart = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
      const gift = cart.items.find((item) => String(item.variant_id) === variantId);
      const qualifies = cart.item_count > 0 && subtotalWithoutGift(cart) >= threshold;

      if (qualifies && !gift) {
        await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        });
      } else if (!qualifies && gift) {
        await fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: gift.key, quantity: 0 })
        });
      } else {
        return;
      }

      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (error) {
      // A failed gift update must never block the cart.
      console.warn('cart-gift', error);
    } finally {
      running = false;
    }
  };

  document.addEventListener('cart:change', sync);
  document.addEventListener('DOMContentLoaded', sync);
})();
